import UserService from "../../services/UserService";

const RenderOnAnonymous = ({ children }) => {
    return (!UserService.isLoggedIn()) ? children : null;
}

export default RenderOnAnonymous
